import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { get, set, isFunction, reduce } from 'lodash-es';
import askingRobotImage from '../../images/ResourcesForYou/Quiz/ic_Quiz-Normal.png';
import correctRobotImage from '../../images/ResourcesForYou/Quiz/ic_Quiz-Correct.png';
import incorrectRobotImage from '../../images/ResourcesForYou/Quiz/ic_Quiz-Incorrect.png';
import nextQuestionImage from '../../images/ResourcesForYou/Quiz/btn_Quiz-Next.png';
import retryQuizImage from '../../images/ResourcesForYou/Quiz/btn_Quiz-Retry.png';

let nextInstanceId = 1;

class Quiz extends Component {
    constructor(props) {
        super(props);
        this.instanceId = nextInstanceId;
        ++nextInstanceId;
        this.state = this.getInitialQuizState();
        this.handleRetryQuiz = this.handleRetryQuiz.bind(this);
        this.handleRadioButtonChange = this.handleRadioButtonChange.bind(this);
        this.handleGoToNextQuestion = this.handleGoToNextQuestion.bind(this);
    }

    getInitialQuizState() {
        return {
            currentQuestionIndex: 0,
            userAnswers: [
                // {
                //     userChoice: boolean | 'do_not_know',
                //     correctAnswer: boolean
                // }, ...
            ],
            isShowingQuizResultPage: false,
            selectedRadioButton: null
        };
    }

    render() {
        return get(this, 'state.isShowingQuizResultPage') ?
            this.renderQuizResult() :
            this.renderQuestion();
    }

    renderQuestion() {
        const { t } = this.props;
        const instanceId = this.instanceId;
        const quizData = get(this, 'props.quizData');

        if (!quizData) {
            return <div className="quiz quiz-question">
                <div className="quiz-content"></div>
            </div>;
        }

        const questions = get(quizData, 'questions');
        const { currentQuestionIndex, selectedRadioButton, userAnswers } = this.state;
        const currentQuestionData = get(questions, currentQuestionIndex);
        const currentUserAnswer = get(userAnswers, currentQuestionIndex);
        const correctAnswer = get(currentUserAnswer, 'correctAnswer');
        const questionNumber = currentQuestionIndex + 1;
        const isAnswerCorrect = get(currentUserAnswer, 'userChoice') === correctAnswer;
        let answerRobotImage;
        let answerExplanationTag = 'PrimaryQuiz:page.';
        if (!currentUserAnswer) {
            answerRobotImage = askingRobotImage;
        } else if (isAnswerCorrect) {
            answerRobotImage = correctRobotImage;
            answerExplanationTag += 'correct';
        } else {
            answerRobotImage = incorrectRobotImage;
            answerExplanationTag += 'incorrect';
        }

        return <div className="quiz quiz-question">
            <div className="quiz-title">
                <h1>{t("PrimaryQuiz:page.title")}</h1>
            </div>
            <div className="quiz-content">
                <div className="robot-logo">
                    <img src={answerRobotImage} alt="" width="300" />
                </div>
                <div className="question-area">
                    <h3>{questionNumber}. {t("PrimaryQuiz:page.description")}</h3>
                    <div className="question-text">
                        {get(currentQuestionData, 'text')}
                    </div>
                    <div className="quiz-answer-choices">
                        <div className="quiz-answer-choice">
                            <input
                                type="radio"
                                name="quiz_answer"
                                onChange={this.handleRadioButtonChange}
                                id={'quiz_answer_true_' + instanceId}
                                value="true"
                                checked={selectedRadioButton === 'true'}
                            />
                            <label htmlFor={'quiz_answer_true_' + instanceId}>
                            {t("PrimaryQuiz:page.answers.true")}
                            </label>
                        </div>
                        <div className="quiz-answer-choice">
                            <input
                                type="radio"
                                name="quiz_answer"
                                onChange={this.handleRadioButtonChange}
                                id={'quiz_answer_false_' + instanceId}
                                value="false"
                                checked={selectedRadioButton === 'false'}
                            />
                            <label htmlFor={'quiz_answer_false_' + instanceId}>
                            {t("PrimaryQuiz:page.answers.false")}
                            </label>
                        </div>
                        <div className="quiz-answer-choice">
                            <input
                                type="radio"
                                name="quiz_answer"
                                onChange={this.handleRadioButtonChange}
                                id={'quiz_answer_do_not_know_' + instanceId}
                                value="do_not_know"
                                checked={selectedRadioButton === 'do_not_know'}
                            />
                            <label htmlFor={'quiz_answer_do_not_know_' + instanceId}>
                            {t("PrimaryQuiz:page.answers.dontKnow")}
                            </label>
                        </div>
                    </div>
                    <div className={'quiz-answer-feedback' + (currentUserAnswer ? '' : ' hide-quiz-answer-feedback')}>
                        <div className="feedback-text">
                            {t(answerExplanationTag) + ' ' + get(currentQuestionData, 'answerExplanation')}
                        </div>
                        <div className="next-question-button-div">
                            <img
                                className="next-question-button"
                                onClick={this.handleGoToNextQuestion}
                                src={nextQuestionImage}
                                alt="Go to next question"
                                width="60"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="quiz-footer">{questionNumber} / {get(questions, 'length')}</div>
        </div>;
    }

    renderQuizResult() {
        const { t } = this.props;
        const userAnswers = get(this, 'state.userAnswers');
        const scoreBreakdown = reduce(userAnswers, (breakdown, userAnswer) => {
            const userChoice = userAnswer.userChoice;
            if (userChoice === userAnswer.correctAnswer) {
                ++breakdown.correctAnswerCount;
            } else if (userChoice === 'do_not_know') {
                ++breakdown.doNotKnowCount;
            } else {
                ++breakdown.incorrectAnswerCount;
            }
            return breakdown;
        }, {
            correctAnswerCount: 0,
            incorrectAnswerCount: 0,
            doNotKnowCount: 0
        });

        const { correctAnswerCount, incorrectAnswerCount, doNotKnowCount } = scoreBreakdown;
        const score = correctAnswerCount / (correctAnswerCount + incorrectAnswerCount + doNotKnowCount) * 100;

        return <div className="quiz quiz-result">
            <div className="quiz-title">
                <h1>{t("PrimaryQuiz:page.title")}</h1>
            </div>
            <div className="quiz-content">
                <div className="score">
                    <div className="score-circle">
                        <div className="score-value">
                            <span className="score-number">{score.toFixed(0)}</span>%
                        </div>
                    </div>
                </div>
                <ul className="score-breakdown">
                    <li><b>{correctAnswerCount}</b> {t("PrimaryQuiz:page.results.correctAnswer")}</li>
                    <li><b>{incorrectAnswerCount}</b> {t("PrimaryQuiz:page.results.incorrectAnswer")}</li>
                    <li><b>{doNotKnowCount}</b> {t("PrimaryQuiz:page.results.dontKnow")}</li>
                </ul>
            </div>
            <div className="quiz-footer">
                <button onClick={this.handleRetryQuiz}>
                    <img src={retryQuizImage} alt="" />
                    {t("PrimaryQuiz:footer.retry")}
                </button>
            </div>
        </div>;
    }

    handleRetryQuiz() {
        this.setState(this.getInitialQuizState());
        const onRetryQuiz = get(this, 'props.onRetryQuiz');
        if (isFunction(onRetryQuiz)) {
            onRetryQuiz();
        }
    }

    handleRadioButtonChange(evt) {
        const { currentQuestionIndex, userAnswers } = this.state;
        const { quizData, onQuestionAnswered } = this.props;
        const radioValue = evt.target.value;
        const currentQuestionData = get(quizData, ['questions', currentQuestionIndex]);
        let currentUserAnswer = get(userAnswers, currentQuestionIndex);
        let correctAnswer;
        if (currentUserAnswer) {
            correctAnswer = get(currentUserAnswer, 'correctAnswer');
        } else {
            currentUserAnswer = {};
            set(userAnswers, [currentQuestionIndex], currentUserAnswer);
        }
        if (!correctAnswer) {
            correctAnswer = get(currentQuestionData, 'correctAnswer');
            currentUserAnswer.correctAnswer = correctAnswer;
        }
        if (radioValue === 'true' || radioValue === 'false') {
            currentUserAnswer.userChoice = radioValue === 'true';
        } else {
            currentUserAnswer.userChoice = radioValue;
        }
        this.setState({
            selectedRadioButton: radioValue
        });
        if (isFunction(onQuestionAnswered)) {
            onQuestionAnswered(currentUserAnswer, currentQuestionIndex, currentQuestionData);
        }
    }

    handleGoToNextQuestion() {
        const { currentQuestionIndex, userAnswers } = this.state;
        const { quizData, onAnotherQuestionShown, onQuizResultCalculated } = this.props;
        const questions = get(quizData, 'questions');
        const nextQuestionIndex = currentQuestionIndex + 1;
        const newState = {
            currentQuestionIndex: nextQuestionIndex,
            selectedRadioButton: null
        };
        if (nextQuestionIndex < questions.length) {
            this.setState(newState);
            if (isFunction(onAnotherQuestionShown)) {
                onAnotherQuestionShown(nextQuestionIndex, questions[onAnotherQuestionShown]);
            }
        } else {
            newState.isShowingQuizResultPage = true;
            this.setState(newState);
            if (isFunction(onQuizResultCalculated)) {
                onQuizResultCalculated(userAnswers);
            }
        }
    }
}

// quizData = {
//     questions: [{
//         text: 'Question 1',
//         answerExplanation: 'answer explanation after user provided their anwser',
//         correctAnswer: true
//     }, {
//         text: 'Question 2',
//         answerExplanation: 'answer explanation after user provided their anwser',
//         correctAnswer: false
//     }, ...]
// }

Quiz.propTypes = {
    quizData: PropTypes.object,
    onQuestionAnswered: PropTypes.func, // the same question can be answered multiple times with different answers
    onAnotherQuestionShown: PropTypes.func,   // current question index is 0-based
    onQuizResultCalculated: PropTypes.func,
    onRetryQuiz: PropTypes.func,
};

export default withTranslation()(Quiz);